
import Injection = EECore.Injection;
import QuerySuggestService from "../../services/documentCentre/querySuggestService";
import SearchService from "../../services/documentCentre/searchService";
import SearchBarBehavior from "../../behaviors/documentCentre/advancedSearchBarBehavior";

@Injection.injectableClass("EEWidget.DocumentCentre.AdvancedSearchBar")
export default class AdvancedSearchBar implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("EEWidget.DocumentCentre.AdvancedSearchBar", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("EEWidget.DocumentCentre.AdvancedSearchBar", "DocumentCentreSearchService")
  private searchService: SearchService;

  @Injection.injectableProperty("EEWidget.DocumentCentre.AdvancedSearchBar", "EEWidget.DocumentCentre.QuerySuggestService")
  private querySuggestService: QuerySuggestService;

  @Injection.injectableProperty("EEWidget.DocumentCentre.AdvancedSearchBar", EECore.Registrations.TEALIUM)
  private tealium: EECore.Tealium;

  @Injection.injectableProperty("EEWidget.DocumentCentre.AdvancedSearchBar", "DocumentCentreAdvancedSearchBarBehavior")
  private searchBarBehavior: SearchBarBehavior;

  @Injection.injectableProperty("EEWidget.DocumentCentre.AdvancedSearchBar", EECore.Registrations.INTEGRATION_CONTEXT)
  private integrationContext: EECore.Integration.Context;

  constructor(templateFactory: EECore.UI.TemplateFactory, searchService: SearchService, querySuggestService: QuerySuggestService, tealium: EECore.Tealium,
    searchBarBehavior: SearchBarBehavior, integrationContext: EECore.Integration.Context) {
    this.templateFactory = templateFactory;
    this.searchService = searchService;
    this.querySuggestService = querySuggestService;
    this.tealium = tealium;
    this.searchBarBehavior = searchBarBehavior;
    this.integrationContext = integrationContext;
  }

  load(): Element {
    const component = this.renderTemplate();
    this.setSearchButtonImagePath(component);
    this.bindUIEvents(component);

    const request = this.searchService.isSearchEnabled();
    request.then((enabled) => {
      if (enabled === false) {
        this.searchBarBehavior.disableSearch(component);
      }
    });
    return component;
  }

  private setSearchButtonImagePath(component: Element) {
    const image = component.querySelector("button > img") as HTMLImageElement;
    image.src = this.integrationContext.environment.baseCdnUrl + image.getAttribute("data-src");
  }

  private renderTemplate(): Element {
    return this.templateFactory.getTemplate("DocumentCentreAdvancedSearchBar", null);
  }

  private bindUIEvents(component: Element) {
    const searchBar = component.querySelector("input[type=text]") as HTMLInputElement;
    searchBar.addEventListener("keydown", (event: KeyboardEvent) => {
      if (event.which === 13) this.searchDocuments(searchBar.value);
    });

    const suggestionContainer = component.querySelector(".we_searchBarSuggestions") as HTMLElement;
    searchBar.addEventListener("input", () => {
      this.displaySuggestions(searchBar.value, suggestionContainer);
    });

    let suggestionsHideTimer: number = null;
    searchBar.addEventListener("blur", () => {
      if (!suggestionsHideTimer) {
        suggestionsHideTimer = window.setTimeout(() => {
          suggestionContainer.style.display = "none";
        }, 500);
      }
    });

    searchBar.addEventListener("focus", () => {
      if (suggestionsHideTimer) {
        window.clearTimeout(suggestionsHideTimer);
        suggestionsHideTimer = null;
      }
      this.displaySuggestions(searchBar.value, suggestionContainer);
    });

    const searchButton = component.querySelector("button[data-action=search]");
    searchButton.addEventListener("click", () => {
      this.searchDocuments(searchBar.value);
    });

    suggestionContainer.addEventListener("click", (event) => {
      let target = event.target as Element;
      while (target.tagName.toLowerCase() !== "div") target = target.parentElement;
      const searchExpression = target.getAttribute("data-search-expression");
      if (searchExpression) {
        this.searchDocuments(searchExpression);
      }
    });
  }

  private searchDocuments(keywords: string) {
    this.tealium.trackLink("Search Keywords", keywords, "Documentation Center");
    this.searchService.searchByKeywords(keywords);
  }

  private displaySuggestions(keywords: string, container: HTMLElement) {
    const request = this.querySuggestService.getSuggestions(keywords);
    request.then((suggestions) => {
      let content = "";
      for (let i = 0; i < suggestions.length; i++) {
        content += `<div data-search-expression="${suggestions[i].searchExpression}">${suggestions[i].content}</div>`;
      }

      container.innerHTML = content;
      container.style.display = content ? "block" : "none";
    });
  }
}